import { Avatar } from '@material-ui/core';
import { createSelector } from '@reduxjs/toolkit';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { userDataSelector } from '../../store/selectors';

const formattedUserDataSelector = createSelector(
  userDataSelector,
  (user) => user || {},
);
const ProfileIcon = () => {
  const { address, imageUrl } = useSelector(
    formattedUserDataSelector,
  );
  return <SAvatar alt={address} src={imageUrl} />;
};

export default ProfileIcon;
const SAvatar = styled(Avatar)`
  &.MuiAvatar-root {
    width: 50px;
    height: 50px;
  }
`;
